import _ from "lodash";
import moment from "moment-jalaali";
import jalaali from "jalaali-js";
import { DateObject } from "react-multi-date-picker";
import { persian, customLocale, gregorian } from "../../app/pages/_Components/customLocale";

export const numberRegex = /^[\u06F0-\u06F9\u0030-\u0039\u002E\u066B]+$/;
export const numberRegexForLatLng = /[^0-9\u06F0-\u06F9.]$/
export const numberWithDotRegex = /^[+-]?(\d+(\.\d*)?|\.\d+)$/

export const tools = {
  formatShamsiDate: (date) => date.toString().replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3'),
  generateRandomColor: () => {
    const hue = Math.floor(Math.random() * 360);
    // تبدیل HSL به RGB برای گرفتن Hex
    const h = hue / 360;
    const s = 0.7; // ثابت
    const l = 0.3; // ثابت

    let r, g, b;
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;

    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);

    const toHex = (x) => Math.round(x * 255).toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  },
  makeCapitalCase: (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.toLowerCase().slice(1);
  },
  toLowerCase: (s) => {
    if (typeof s !== "string") return "";
    return s.toLowerCase();
  },
  parseBool: (str) => {
    let val = false;
    if (typeof str === "string") {
      if (str.trim().toLowerCase() === "true") {
        val = true;
      } else if (str.trim().toLowerCase() === "false") {
        val = false;
      }
      return val;
    } else {
      return str;
    }
  },
  justNumber: (str) => {
    let result = str.replace(/[^\d]/g, "");
    return result;
  },

  justEnglish: (value) => {
    return `${value}`.replace(/[^a-zA-Z\s]/g, "");
  },

  isObject: (data) => {
    return data && typeof data === "object";
  },

  toObject(data) {
    return this.isObject(data) ? data : {};
  },

  isArray: (data) => {
    return data && typeof data === "object" && data.constructor === Array;
  },
  toArray(data) {
    return this.isArray(data) ? data : [];
  },
  arrayPad: (arr, len, fill) => {
    return arr.concat(Array(len).fill(fill)).slice(0, len);
  },

  jsonDecode: (json) => {
    try {
      return JSON.parse(json);
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  previewFile: (fileBlob, callback = () => { }) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(fileBlob);
  },

  joinDurationObject: (duration) => {
    const { hours, minutes, seconds } = duration || {};
    const array = [];
    if (hours) {
      array.push(`${hours} hours`);
    }
    if (minutes) {
      array.push(`${minutes} minutes`);
    }
    if (seconds) {
      array.push(`${seconds} seconds`);
    }

    return array.join(" : ");
  },

  /**
   * Find specific field error message from errorArray
   * @param {{field: String, errorMessage: String}[]} errorArray
   * @param {string} fieldName the field's name that you want to look for into errorArray
   * @return {string} field error message if found. otherwise return empty string
   */
  findErrorMessage: (errorArray, fieldName) => {
    const t = errorArray.find((x) => x.field === fieldName);
    if (t) {
      return t.errorMessage;
    } else {
      return "";
    }
  },
  /**
   * Get Validation model, and input data object then return result array that we can store it into errors Array. if there is no error, it will be empty
   * @param {Schema} validationModelSchema
   * @param {Object} inputObject object of values that contain field's name for each input
   * @return {{field: String, errorMessage: String}[]}
   */
  applyModelCheckValidation: (validationModelSchema, inputObject) => {
    let result = [];
    const checkResult = validationModelSchema.check(inputObject);
    for (let key in checkResult) {
      let value = checkResult[key];
      if (value.hasError) {
        result.push({ field: key, errorMessage: value.errorMessage });
      }
    }
    return result;
  },
  //گروه بندی دیتا ورودی از ای پی آی  ورودی ها دیتا برگشته از ای پی ای و کی هم نام فیلد برای گروه بندی برحسب رشته
  groupByListBasketItem: (array, key) => {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, {});
  },
  setInputsValues_ReactHookFrom: (setValue, formValues, formInputs) => {
    (async () => {
      try {
        formValues.forEach((value, key) => {
          const foundObject = formInputs.find(obj => obj.name === key);
          if (foundObject) {
            switch (foundObject.type) {
              case 'text': {
                setValue(`${key}`, `${value}`);
              }
                break;
              case 'datePicker':
                var splitValueFromUrl = `${value}`.split("/");
                if (splitValueFromUrl.length > 2) {
                  const value = {
                    year: splitValueFromUrl[0],
                    month: splitValueFromUrl[1],
                    day: splitValueFromUrl[2],
                  };
                  setValue(`${key}`, `${value.year}/${("0" + value.month).slice(-2)}/${("0" + value.day).slice(-2)}`)
                }
                break;
              case "multiSelect": {
                const splitValueFromUrl = `${value}`.split(",");
                // فیلتر کردن آرایه براساس مقادیر جدا شده
                const valueList = foundObject.data
                  .filter((item) => splitValueFromUrl.includes(item.id ? item.id.toString() : `${item.value}`))
                  .map((obj) => {
                    // اگر فیلد name در آبجکت وجود دارد، آن را به title تغییر دهید
                    if (obj.hasOwnProperty("name")) {
                      return { ...obj, title: obj.name, name: undefined };
                    }
                    return obj;
                  });
                // اگر isMulti ست نشده بود، پیش‌فرض true در نظر بگیر
                const isMulti = !!foundObject.isMulti;

                if (isMulti) {
                  setValue(`${key}`, valueList.map((item) => ({
                    value: item.id,
                    label: item.title,
                    labelId: item.id,
                  })));
                } else {
                  const selected = valueList.length > 0 ? valueList[0] : null;
                  setValue(`${key}`, selected ? {
                    value: selected.id ?? selected.value,
                    label: selected.title ?? selected.label,
                    labelId: selected.id ?? selected.id ?? selected.value,
                  } : null);
                }
              }
                break;
              case 'multiSelectInGroup': {
                const splitValueFromUrl = `${value}`.split(',');

                // data باید به صورت آرایه‌ای از گروه‌ها با کلید options باشد
                const flatOptions = foundObject.data
                  ?.flatMap(group => group.options) || [];

                const values = flatOptions
                  .filter(item => splitValueFromUrl.includes(item.value?.toString()))
                  .map(item => ({
                    value: item.value,
                    label: item.label,
                    labelId: item.value,
                  }));
                setValue(`${key}`, values);
                break;
              }
              case 'number':
                var value = !_.isEmpty(`${value}`) ? _.toNumber(`${value}`) : 1;
                setValue(`${key}`, value);
              default:
            }
          }
        });


      } catch (error) {
        console.log(error)
      } finally {
      }
    })();


  },
  createQueryStringFromFromData: (data) => {
    let queryString = '';
    Object.entries(data).forEach(([key, value], index) => {
      const isEmptyArray = _.isArray(value) ? _.isEmpty(value) : false;
      if (value !== undefined && value !== "" && !isEmptyArray) {
        if (Array.isArray(value)) {
          queryString += `${(key)}=${(value.join(','))}`;
        } else {
          queryString += `${(key)}=${(value)}`;
        }
        if (index >= 0) {
          queryString += '&';
        }
      }
    });
    return queryString;
  },
  DateFormat: (date) => {
    if (date) {
      var newDate = `${date.year}/${("0" + date.month).slice(-2)}/${("0" + date.day).slice(-2)}`;
      return newDate;
    }
    else
      return "";
  },

  // قرار دادن مقدار pageNumber به 1 زمانی که بقیه فیلدها خالی نباشد
  setPageNumber: (data, oldSearchParams, setValue) => {
    Object.entries(data).every(item => {
      let [key, value] = item;
      if (["pageNumber", "pageSize", "totalPages", "totalCount"].includes(key)) {
        return true // it means continue the loop
      }
      // console.log("key", key, oldSearchParams.get(key))
      // console.log("isEmpty", key, _.isEmpty(oldSearchParams.get(key)))
      // console.log("isEmpty value", value, _.isEmpty(value))

      value = _.isNumber(value) ? _.toString(value) : value

      if (!_.isEmpty(oldSearchParams.get(key))) {
        if (_.isArray(value)) {
          let oldSearchParamsArray = oldSearchParams.get(key).split(',').map(i => Number(i));
          let convertedValue = value.map(item => typeof item == "string" ? item.split(",").map(i => Number(i)) : item)

          if (!_.isEqual(oldSearchParamsArray, convertedValue.flat(1))) {
            data.pageNumber = 1;
            setValue("pageNumber", 1)
          }
        }
        else
          if (value != oldSearchParams.get(key)) {
            data.pageNumber = 1;
            setValue("pageNumber", 1)
          }
      }
      else if (!_.isEmpty(value)) {
        data.pageNumber = 1;
        setValue("pageNumber", 1)
      }

      return true
    })

    for (const key in data) {
      if (data[key] === null) {
        data[key] = undefined
      }
    }
  },

  handleResetAdvanceSearchBox: (watch, reset) => {
    // ریست کردن همه فیلد ها در ریکت هوک فرم به جز موارد پایین در آرایه
    const excludedFieldsArray = ["pageNumber", "pageSize", "globalSearch", "totalCount", "totalPages"];
    const formFieldStates = { ...watch() };
    const excludedFields = {};
    Object.entries(formFieldStates).forEach((item) => {
      const [key, value] = item;
      if (excludedFieldsArray.includes(key)) {
        excludedFields[key] = value;
      }
    });
    reset({ ...excludedFields });
  },
  formatPriceNumber: (value) => {
    const stringValue = String(value);
    return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  getShamsiDateTime: () => {
    const date = new Date();
    const shamsiDate = new DateObject({ calendar: persian, locale: customLocale });
    const hour = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const time = `${hour}:${minutes}`; // ##:## format
    return { shamsiDate, time };
  },
  toEnglishDigits: (str) => {
    const persian = "۰۱۲۳۴۵۶۷۸۹";
    const arabic = "٠١٢٣٤٥٦٧٨٩";

    return str.replace(/[۰-۹٠-٩]/g, d => {
      let index = persian.indexOf(d);
      if (index === -1) index = arabic.indexOf(d);
      return index > -1 ? index : d;
    });
  },
  dateConverter: (date) => {
    if (!_.isUndefined(date)) {
      if (typeof date == "object") {
        const dp = new DateObject({
          date,
          calendar: persian,
          locale: customLocale
        })
        return moment(
          dp.year +
          "/" +
          ("0" + dp.month).slice(-2) +
          "/" +
          ("0" + dp.day).slice(-2),
          "jYYYY/jM/jD"
        ).format("YYYY-M-D");
      }
      else {
        return moment(date, "jYYYY/jMM/jDD").format(
          "YYYY-M-D"
        );
      }
    }
  },
  isValidIranNationalId: (id) => {
    if (!/^(?!([0-9])\1{9})\d{10}$/.test(id)) return false;

    const check = parseInt(id[9]);
    const sum = id
      .slice(0, 9)
      .split('')
      .reduce((acc, digit, i) => acc + parseInt(digit) * (10 - i), 0);

    const mod = sum % 11;
    return (mod < 2 && check === mod) || (mod >= 2 && check === 11 - mod);
  },
  setCustomDate: function (daysNumber) {
    const today = new Date();
    const arbitaryDate = new Date(today);
    arbitaryDate.setDate(today.getDate() + daysNumber)
    const formattedToday = this.toJalaali(today);
    const formattedArbitaryDate = this.toJalaali(arbitaryDate);
    return { formattedToday, formattedArbitaryDate }
  },
  toJalaali: function (date) {
    const jDate = jalaali.toJalaali(date);
    return this.convertDate({ year: jDate.jy, month: jDate.jm, day: jDate.jd })
  },
  convertDate: (item) => {
    // this is old one ↓↓
    // return `${jDate.jy}/${("0" + jDate.jm).slice(-2)}/${("0" + jDate.jd).slice(-2)}`;
    if (item) {
      return (item.year + "/" + (item.month < 10 ? ("0" + item.month) : item.month) + "/" + (item.day < 10 ? "0" + item.day : item.day));
    }
    else
      return "";
  },
  locationValidation(lat, lng) {
    if (lat && !lng)
      return { lonValidation: "مقدار lon را وارد نمایید !", latValidation: true }
    if (lng && !lat)
      return { lonValidation: true, latValidation: "مقدار lat را وارد نمایید !" }
    if (!lat && !lng)
      return { latValidation: true, lonValidation: true }

    const lonValidation = +lng >= -180 && +lng <= 180 || "lon نامعتبر می باشد !"
    const latValidation = +lat >= -90 && +lat <= 90 || "lat نامعتبر می باشد !"

    return { lonValidation, latValidation }
  },
  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  },
  getDateRange({
    direction = "future",
    range = "week",
    customDate = "",
  }) {
    // تاریخ امروز بر اساس ساعت محلی سیستم
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let days = 7;

    if (range === "twoWeeks") {
      days = 14;
    } else if (range === "month") {
      // استفاده از moment-jalaali برای محاسبه دقیق تعداد روزهای ماه جاری شمسی
      const jDate = moment(today);

      // در moment-jalaali، متد jMonth() از 0 شروع می‌شود (0 = فروردین، 11 = اسفند)
      // متد jDaysInMonth به صورت خودکار تعداد روزهای ماه را برمی‌گرداند
      // (اعم از 31، 30، 29 یا 30 برای اسفند)
      const jYear = jDate.jYear();
      const jMonth = jDate.jMonth();

      days = moment.jDaysInMonth(jYear, jMonth);
    }

    let fromDate;
    let toDate;

    if (range === "custom") {
      if (!customDate) {
        throw new Error("لطفاً تاریخ دلخواه را انتخاب کنید.");
      }

      // ورودی type="date" با فرمت YYYY-MM-DD
      const customSelceted = this.toEnglishDigits(typeof customDate == "string" ? customDate : customDate.convert(gregorian).format("YYYY-MM-DD"));
      const selectedDate = new Date(customSelceted);
      selectedDate.setHours(0, 0, 0, 0);

      if (direction === "future") {
        fromDate = today;
        toDate = selectedDate;
      } else {
        fromDate = selectedDate;
        toDate = today;
      }
    } else if (direction === "future") {
      fromDate = today;
      toDate = this.addDays(today, days);
    } else {
      fromDate = this.addDays(today, -days);
      toDate = today;
    }

    if (fromDate > toDate) {
      throw new Error(
        direction === "future"
          ? "تاریخ انتخابی باید امروز یا بعد از امروز باشد."
          : "تاریخ انتخابی باید امروز یا قبل از امروز باشد."
      );
    }

    return {
      fromDate: this.toJalaali(fromDate),
      toDate: this.toJalaali(toDate),
    };
  },
  getDaysDifference(date1) {
    const d1 = new Date(date1);
    const d2 = new Date();

    // تبدیل به UTC نیمه‌شب برای حذف ساعت و جلوگیری از مشکل DST
    const utc1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    const utc2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());

    const diffMs = utc2 - utc1;
    const diffDays = Math.abs(diffMs) / (1000 * 60 * 60 * 24);

    return diffDays;
  }
};
